export class JobPostingSchema {

    constructor() {

        this.identifier = new Identifier();
        this.hiringOrganization = new HiringOrganization();
        this.jobLocation = new JobLocation();
        this.jobLocation.address = new Address();
        this.baseSalary = new BaseSalary();
        this.baseSalary.value = new BaseSalaryValue();
    }

    "@context" = "https://schema.org/";
    "@type" = "JobPosting";
    
    title: string;
    description: string;
    identifier: Identifier;
    datePosted: any;
    validThrough: any;
    employmentType: string;
    hiringOrganization: HiringOrganization;
    jobLocation: JobLocation;
    baseSalary: BaseSalary;
    industry:string = "UNSPECIFIED";
    image:string ="UNSPECIFIED";
}

export class Identifier {

    "@type": string = "PropertyValue";
    name: string = "Apply4U";
    value: number;
}

export class HiringOrganization {

    "@type": string = "Organization";
    name: string;
    sameAs: string = "https://www.apply4u.co.uk";
    logo: string;
}

export class JobLocation {

    "@type": string = "Place";
    address:Address;
}

export class Address {

    "@type":string = "PostalAddress";
    streetAddress:string = "UNSPECIFIED";
    addressLocality:string = "UNSPECIFIED";
    addressRegion:string = "UNSPECIFIED";
    postalCode:string = "UNSPECIFIED";
    addressCountry:string="UK";
}

export class BaseSalary{

    "@type":string = "MonetaryAmount";
    currency:string = "GBP";
    value:BaseSalaryValue;
}

export class BaseSalaryValue{

    "@type":string = "QuantitativeValue";
    minValue:number;
    maxValue:number;
    unitText:string;
}